import { isArray, isEmpty, isObject, values } from 'lodash';
import { ErrorMessage } from '~domain/model/core/validation/rule';

// Returns true if error message has any error message
export function hasValidationErrors(errorMessage: ErrorMessage): boolean {
  if (isArray(errorMessage)) return errorMessage.some((e) => hasValidationErrors(e));
  if (isObject(errorMessage)) return values(errorMessage).some((value) => hasValidationErrors(value));

  return !isEmpty(errorMessage);
}
